import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import {
  Table,
  Tbody,
  Tr,
  Th,
  Td,
  Thead,
} from "@chakra-ui/react";
import { MdOutlineFileDownload } from "react-icons/md";
import { useEffect, useState } from "react";
import Pagination from "react-bootstrap/Pagination";
import { fetchAsyncDownloadSharePointFile } from "redux/userSlice";
import { useToasts } from "react-toast-notifications";
import { useDispatch } from "react-redux";
import { Spinner } from "react-bootstrap";

const PaymentDetailInfo = ({ selectedItem }) => {
  const [excelData, setExcelData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 3;
  const { addToast } = useToasts();
  const dispatch = useDispatch();

  const splitTitle = (Key) => {
    let label = "";
    if (Key) {
      let splitKey = Key.split("/");
      label = Key && splitKey[splitKey.length - 1];
    }
    return label;
  };
  const [isLoading,setIsLoading] = useState(false)


  const handleDownload = async (key, spId) => {
    setIsLoading(true)

      try {
        const response = await dispatch(fetchAsyncDownloadSharePointFile({spId,key})).unwrap();
        if (response && response.downloadUrl) {  
          const fileUrl = response.downloadUrl;  
          const link = document.createElement("a");
          link.href = fileUrl;
          link.download = fileUrl.split('/').pop();  
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          addToast(`Excel file downloaded successfully!`, { appearance: "success" });
          setIsLoading(false)

        } else {
          addToast(`Error downloading file: The requested file could not be found.`, { appearance: "error" });
          setIsLoading(false)

          }
      } catch (error) {
        addToast(`Error downloading file: The requested file could not be found.`, { appearance: "error" });
        setIsLoading(false)

      }
        
    
  };

  useEffect(() => {
    if (selectedItem?.exDts && selectedItem?.exDts.length > 0) {
      
      setExcelData(selectedItem?.exDts);
    }
  }, [selectedItem]);

  // Calculate pagination details
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = excelData.slice(indexOfFirstItem, indexOfLastItem);
  const pageCount = Math.ceil(excelData.length / itemsPerPage);


return (
    <>
      <Row className="info-row">
        <Col className="check-cross-mark mt-0">
          <Form.Label>
            <span className={excelData.length ? "checkmark" : "crossmark"}></span>{" "}
            Excel Sheet Attached?
          </Form.Label>
        </Col>
      </Row>
      {excelData.length ? (
        <div className="info-table">
          <Table size="md" variant="striped">
            <Thead>
              <Tr>
                <Th>No.</Th>
                <Th>Title</Th>
                <Th>Payment Type</Th>
                <Th>Action</Th>
              </Tr>
            </Thead>
            <Tbody>
              {currentItems.map((item, index) => (
                <Tr key={index}>
                  <Td>{indexOfFirstItem + index + 1}</Td>
                  <Td>{splitTitle(item?.Key)}</Td>
                  <Td>{item?.excelTypeId?.value}</Td>
                  <Td style={{ textAlign: "center" }}>
                  {isLoading ?
                  <Spinner size="sm"/>
                :

                    <MdOutlineFileDownload
                      style={{ cursor: "pointer" }}
                      onClick={(e) => {
                        e.preventDefault();
                        handleDownload(item.Key,item?.spId);
                      }}
                    />
                  }
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>

          {/* Pagination Component */}
          <Pagination className="justify-content-end" style={{ marginTop: '20px' }}>
            <Pagination.Prev 
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))} 
              disabled={currentPage === 1} 
            />
            {Array.from({ length: pageCount }, (_, i) => (
              <Pagination.Item
                key={i + 1}
                active={i + 1 === currentPage}
                onClick={() => setCurrentPage(i + 1)}
              >
                {i + 1}
              </Pagination.Item>
            ))}
            <Pagination.Next 
              onClick={() => setCurrentPage((prev) => Math.min(prev + 1, pageCount))} 
              disabled={currentPage === pageCount} 
            />
          </Pagination>
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default PaymentDetailInfo;
